var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"presentation-owner"},[_c('aha-avatar',{staticClass:"mr-1 flex-shrink-0",attrs:{"name":_vm.ownerName,"image":_vm.ownerAvatar,"id":_vm.ownerId}}),_c('div',{staticClass:"presentation-owner__name"},[_vm._v("\n    "+_vm._s(_vm.ownerName)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }